import type { Handleiding } from './soort';

export const tr: Handleiding = {
  code: 'tr',
  titel: 'Kılavuz',
  inleiding:
    'Ask Gio Tolk, aynı dili konuşmayan iki kişi arasındaki bir sohbeti çevirir. Aşağıda her düğmenin ne yaptığı yazıyor.',
  knop: 'Kılavuzu aç',
  sluiten: 'Kapat',
  groepGebruik: 'Sohbete katılmak',
  groepBeheer: 'Ayarlamak ve yönetmek',
  delen: [
    {
      titel: 'Konuşma',
      sleutel: 'praten',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Konuş',
          uitleg:
            'Başlamak için bir kez dokun. Bir saniyeden biraz fazla sustuğunda kayıt kendiliğinden durur, ya da bir kez daha dokunursan. Bir dakika sonra zaten durur.',
        },
        {
          kop: 'Aynı anda tek ses',
          uitleg:
            'Uygulama konuştuğu sürece kayıt yapamazsın. Sen kayıt yaptığın sürece de gelen bir çeviri sen bitirene kadar bekler. Yoksa mikrofonun uygulamayı kaydeder ve bunu senin söylediğini sanır.',
        },
        {
          kop: 'Mesajını buraya yaz',
          uitleg:
            'Konuşmanın yanı sıra çalışır ve aynı çeviriden geçer. Enter gönderir, shift ile enter yeni satır yapar.',
        },
        {
          kop: 'Düzeltme süresi',
          uitleg:
            'Yazıya dökülen cümleni gitmeden önce okumak için kaç saniyen olduğunu burada ayarlarsın. Sıfırda hemen gider.',
        },
        {
          kop: 'Her zaman kendin kontrol et ve gönder',
          uitleg:
            'Artık saat yok. Her cümle sen gönder düğmesine basana kadar bekler. Her cümleyi kontrol etmek isteyenler için.',
        },
        {
          kop: 'Çeviriyi hemen oynat',
          uitleg:
            'Açık. Önce okumayı ve ne zaman dinleyeceğine kendin karar vermeyi tercih ediyorsan kapat.',
        },
      ],
    },
    {
      titel: 'Mesajları okuma',
      sleutel: 'lezen',
      groep: 'gebruik',
      open: true,
      punten: [
        {
          kop: 'Büyük yazılan',
          uitleg:
            'SENİN dilinde olan büyük yazılır. Kendi cümlende bu senin özgün metnindir, böylece uygulamanın seni doğru anlayıp anlamadığını kontrol edebilirsin. Karşındakinin cümlesinde ise çeviridir.',
        },
        {
          kop: 'Özgün metni veya çeviriyi açma',
          uitleg: 'Diğer dil altta, kapalı duruyor. Açmak için satıra dokun.',
        },
        {
          kop: 'Küçük üçgen',
          uitleg: 'Çeviriyi yeniden oynatır.',
        },
        {
          kop: 'Konuşan kafa',
          uitleg:
            'Karşındakinin kendi kaydını oynatır. Yalnızca KONUŞULMUŞ bir mesajda ve yalnızca «kendi sesini de gönder» açıksa görünür. Yazılan bir mesajın kaydı yoktur.',
        },
      ],
    },
    {
      titel: 'Ekranın üstündeki düğmeler',
      sleutel: 'knoppen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Eksi ve artı',
          uitleg: 'Metni küçültür veya büyütür. Beş kademede, ve kayıtlı kalır.',
        },
        {
          kop: 'Mikrofon',
          uitleg: 'Zaten sadece yazıyorsan konuşma düğmesini gizler. Bu yer kazandırır.',
        },
        {
          kop: 'Klavye',
          uitleg:
            'Metin kutusunu gizler. İkisinden biri hep açık kalır, yoksa artık hiçbir şey söyleyemezsin.',
        },
      ],
    },
    {
      titel: 'Giriş',
      sleutel: 'binnenkomen',
      groep: 'gebruik',
      punten: [
        {
          kop: 'Hangi dili konuşuyorsun',
          uitleg:
            'Bu seçim düğmelerin ve bildirimlerin dilini de belirler. Yani ikiniz farklı bir ekran görürsünüz, ve amaç budur.',
        },
        {
          kop: 'Çevirideki sesin',
          uitleg:
            'Erkek gibi mi yoksa kadın gibi mi duyulacağını seç. Bu SANA aittir, odaya değil: her katılımcı ayrı seçer.',
        },
        {
          kop: 'Mikrofon izni',
          uitleg:
            'Tarayıcı bunu girişte sorar. Hayır dersen yine de yazabilirsin. İzni sonradan adres çubuğundaki kilitten de verebilirsin.',
        },
      ],
    },
    {
      titel: 'Altta, kapalı',
      sleutel: 'onderin',
      groep: 'beheer',
      punten: [
        {
          kop: 'Güvenlik sözlüğü',
          uitleg:
            'Her zaman aynı şekilde çevrilmesi gereken kelimeler: isimler, teknik terimler, markalar. Tüm oda için geçerlidir.',
        },
        {
          kop: 'Ayarları değiştirme',
          uitleg:
            'Dil, ses, ton ve yazım düzeltmesi sohbetin ORTASINDA da değiştirilebilir. Burada değiştirdiğin şey hemen ikiniz için geçerli olur.',
        },
      ],
    },
    {
      titel: 'Bir sohbet başlatmak',
      sleutel: 'beginnen',
      groep: 'beheer',
      punten: [
        {
          kop: 'Sohbetin adı',
          uitleg:
            'Boş kalabilir. Yalnızca ekranının üstünde durur, kiminle konuştuğunu bilesin diye.',
        },
        {
          kop: 'Konuşmacı 1 ve konuşmacı 2',
          uitleg:
            'Bu sohbetin iki dili. İlk giren ilk sırayı alır. Dilleri sonradan da değiştirebilirsin.',
        },
        {
          kop: 'Çevirinin tonu',
          uitleg:
            'Solda senli benli mi yoksa resmi mi konuşulacağını seçersin, sağda havayı: nötr, samimi, iş, resmi veya eş. Yönlendirme olmadan model neredeyse her zaman resmi biçimi seçer, ve sıradan bir sohbette bu mesafeli durur.',
        },
        {
          kop: 'Kendi sesini de gönder',
          uitleg:
            'Karşındaki çevirinin yanında senin kendi kaydını da duyabilir. Bir dil öğrenmek için pratiktir. Hassas bir sohbette bunu kapat: kaydı alan onu saklayabilir.',
        },
        {
          kop: 'Kendi metnindeki yazım hatalarını düzelt',
          uitleg:
            'Açık. Modelin gerçekte ne anladığını görmek için kapat. O zaman garip bir cümle çıkarsa, yanlış mı anlaşıldığını yoksa doğru anlaşılıp sonra düzeltildiğini bilirsin.',
        },
        {
          kop: 'PIN koduyla',
          uitleg:
            'Kodu sözlü olarak ilet, bağlantıyla aynı mesajda değil. Bu, iletilen bir bağlantıya karşı korur.',
        },
        {
          kop: 'QR kodu',
          uitleg:
            'Karşındakine tarattır, ya da bağlantıyı gönder. Bir oda dört saat sonra kendiliğinden sona erer.',
        },
      ],
    },
    {
      titel: 'Sohbetine ne oluyor',
      sleutel: 'privacy',
      groep: 'beheer',
      punten: [
        {
          kop: 'Metin saklanmıyor',
          uitleg:
            'Söyledikleriniz veritabanına girmez. Yalnızca ne zaman ve ne kadar konuşulduğu, masraflar için.',
        },
        {
          kop: 'Kayıtlar kendiliğinden siliniyor',
          uitleg: 'Ses on dakika bellekte kalır ve sonra gider.',
        },
        {
          kop: 'Oda sona eriyor',
          uitleg: 'Oluşturulduktan dört saat sonra. Ondan sonra bağlantı artık çalışmaz.',
        },
        {
          kop: 'Bir bütçe var',
          uitleg:
            'Oda başına ve ay başına. Dolarsa uygulama çevirmeyi bırakır ve bunu söyler. Bu bir arıza değildir.',
        },
      ],
    },
  ],
};
